import { render, staticRenderFns } from "./BindingPhone.vue?vue&type=template&id=77e89944&"
import script from "./BindingPhone.vue?vue&type=script&lang=js&"
export * from "./BindingPhone.vue?vue&type=script&lang=js&"
import style0 from "./BindingPhone.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports